module.exports = __webpack_public_path__ + "static/media/stories.4d20ebe1.jpg";